$(document).ready(function() {

  var areaFilter = $('#filter_area');
  var allBranches = $('.single-branch');

  areaFilter.on('change', function() {
    
    var selectedArea = $(this).val();

    if (selectedArea === 'all') {
      allBranches.show();
    } else {
      allBranches.hide();
      $('.single-branch[data-area="' + selectedArea + '"]').show();
    }

    updateCount();
    
  });


  function updateCount() {

    var countContainer = $(".num-results");
    var visibleCount = $('.single-branch:visible').length;
    var countText = 'נמצאו ' + visibleCount + ' סניפים';

    if (visibleCount === 1) {
        countText = 'נמצא סניף אחד';
    }else if (visibleCount === 0) {
        countText = 'לא נמצאו סניפים';
    }
    
    countContainer.text(countText);

  }

});